var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-avatar-wrapper"},[_c('img',{staticClass:"image",attrs:{"id":"user-avatar","src":_vm.avatar}}),(_vm.countryCode)?_c('div',{class:("flag flag--round flag--" + (_vm.countryCode.toLowerCase()) + " ff-md")}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }